export enum CustomCellFormatterWrapperBlock {
  Root = 'CustomCellFormatterWrapper',
}
